import React, { Component } from "react";
import {
  InputGroup,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate, customSelectStyles,mapArray } from '../../../lib/common';
import AppConfig from "../../../config/app";
import Moment from "react-moment";
import { storedb } from '../../client/storedb'
import Pagination from "react-js-pagination";
import * as saleConstant from './constants'
import * as saleAction from './actions'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
import Select from 'react-select';
const isNumber = require('is-number');
class SaleReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tong_soLuong: 0,
      tong_doanhThuChuaCK: 0,
      tong_doanhThu: 0,
      tong_doanhSoTDV: 0,
      tong_doanhSoCKKH: 0,
      tong_soLuongTra: 0,
      tong_doanhThuTra: 0,
      tong_diem: 0,
      page: 1,
      per_page: 20,
      multipleValueNVKD: [],
      treeNvkd: [],
      treeKH: [],
      loaiDonHang: "",
      trangThai: [],
      selectedOption: null,
      listNhomKhachHang: [],
      selectedOptionNhomKhachHang: null,
      listKhachHang: [],
      selectedOptionKhachHang: null,
      keyword: "",
      khParam: null
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "loaiDonHang":
        this.setState({ loaiDonHang: selectedOption.target.value })
        break;
      case "TrangThai":
        this.setState({ trangThai: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleChangeTrangThai = selectedOption => {
    var multipleValue = [];
    selectedOption.forEach(function (item) {
      multipleValue.push(parseInt(item.value));
    });
    this.setState({ selectedOption, trangThai: multipleValue });
  };
  handleChangeNhomKhachHang = selectedOptionNhomKhachHang => {
    let { selectedOptionKhachHang } = this.state
    if (selectedOptionNhomKhachHang != null) {
      if (selectedOptionNhomKhachHang.value > 0) {
        this.fetchKHByNhom([selectedOptionNhomKhachHang.value])
      }
    } else {
      selectedOptionKhachHang = null
      //load khách hàng theo nvkd
      let { multipleValueNVKD } = this.state
      if (multipleValueNVKD.length > 0) {
        this.fetchKH(multipleValueNVKD);
      }
    }
    this.setState({ selectedOptionNhomKhachHang, selectedOptionKhachHang });
  };
  handleChangeKhachHang = selectedOptionKhachHang => {
    this.setState({ selectedOptionKhachHang });
  };
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [], selectedOptionKhachHang: null, listKhachHang: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
    if (multipleValue.length > 0) {
      this.fetchKH(multipleValue);
    } else {
      this.setState({ selectedOptionKhachHang: null, listKhachHang: [] });
    }
  }

  onHandleRemoveKH = () => {
    this.setState({ listKhachHang: [] })
  }
  fetchNhomKhachHang = () => {
    const { saleReportNhomKhRequest } = this.props
    var requestData = {
      keyword: '',
      page: 1,
      per_page: 100
    };
    return saleReportNhomKhRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  fetchNvkd = (quanlys) => {
    const { saleReportNvkdRequest } = this.props
    var requestData = {
      store_id: this.state.store_id,
      userIds: quanlys
    };
    return saleReportNvkdRequest(requestData);
  }
  fetchKH = (nvkds) => {
    const { saleReportKhRequest } = this.props
    var requestData = {
      stores_id: this.state.store_id,
      nvkds: nvkds
    };
    return saleReportKhRequest(requestData);
  }
  fetchKHByNhom = (nhomId) => {
    const { saleReportKhByNhomRequest } = this.props
    var requestData = {
      nvkds: this.state.multipleValueNVKD,
      nhomId: nhomId
    };
    return saleReportKhByNhomRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    const { saleReportListRequest } = this.props
    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD,
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang),
      listKH: mapArray(this.state.selectedOptionKhachHang),
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return saleReportListRequest(requestData)
  }
  fetchListInitData(page) {
    const { saleReportListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD,
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang),
      listKH: [this.state.khParam],
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return saleReportListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD.join(","),
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang).join(","),
      listKH: mapArray(this.state.selectedOptionKhachHang).join(","),
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
    };
    return reportExportXlsRequest(requestData, (listEXP) => {
      var dataFile = new Blob([listEXP], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportDoanhSo';
      var fileName = "baocao_doanhso.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportDoanhSo";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.saleReport.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1), // remove the "?" at the start
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  checkKhachHangId = (callback) => {
    let kh = this.getParam("kh");
    let ql = this.getParam("ql");
    let { khParam } = this.state
    var multipleValue = [];
    if (isNumber(ql)) {
      multipleValue.push(parseInt(ql));
      this.fetchKH(multipleValue);
    };
    if (isNumber(kh)) {
      khParam = kh
    };
    this.setState({ khParam, multipleValueNVKD: multipleValue }, callback)
  }
  initData = () => {
    this.fetchNvkd();
    this.fetchNhomKhachHang();
    if (this.state.khParam != null)
      this.fetchListInitData();
  }
  componentDidMount() {
    this.checkKhachHangId(this.initData)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.saleReport.type == saleConstant.SALE_REPORT_NVKD_SUCCESS) {
      let { listNV } = nextProps.saleReport;
      if (listNV && listNV.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        const NvkdChecked = listNV.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      this.setState({
        treeNvkd: listNV
      });
    }
    else if (nextProps.saleReport.type == saleConstant.SALE_REPORT_KH_SUCCESS) {
      let { listKH } = nextProps.saleReport;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      //kiểm tra tham số khách hàng có gọi từ trang khác không
      let kh = this.getParam("kh");
      if (kh != '') {
        let optionKh = listKH.filter(f => f.Id == kh).map((item) => { return { value: item.Id, label: item.Name } })
        if (optionKh.length > 0) {
          selectedOptionKhachHang = optionKh[0]
        }
      } else {
        if (listKH && listKH.length === 1) {
          // neu chi co 1 minh no thì thực hiện set luôn nó
          selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
        };
      }
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    }
    else if (nextProps.saleReport.type == saleConstant.SALE_REPORT_LIST_SUCCESS) {
      let { list, item } = nextProps.saleReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        tong_soLuong: item.tong_soLuong,
        tong_doanhThuChuaCK: item.tong_doanhThuChuaCK,
        tong_doanhThu: item.tong_doanhThu,
        tong_doanhSoTDV: item.tong_doanhSoTDV,
        tong_doanhSoCKKH: item.tong_doanhSoCKKH,
        tong_doanhThuTra: item.tong_doanhThuTra,
        tong_soLuongTra: item.tong_soLuongTra,
        tong_diem: item.tong_diem,
        list: list
      });
    } else if (nextProps.saleReport.type == saleConstant.SALE_REPORT_NHOMKH_SUCCESS) {
      let { listNhomKh } = nextProps.saleReport;
      this.setState({
        listNhomKhachHang: listNhomKh.map((item) => { return { value: item.NhomKhId, label: item.Ten } })
      });
    }
  }
  render() {
    const {
      list,
      treeNvkd,
      selectedOption,
      selectedOptionNhomKhachHang,
      listNhomKhachHang,
      selectedOptionKhachHang,
      listKhachHang
    } = this.state
    const baoCaoTrangThai = [{ value: AppConfig.ORDER_STATUS.HoanThanhNhap, label: AppConfig.ORDER_STATUS.HoanThanhNhapText },
    { value: AppConfig.ORDER_STATUS.DangXuLy, label: AppConfig.ORDER_STATUS.DangXuLyText },
    { value: AppConfig.ORDER_STATUS.HoanThanh, label: AppConfig.ORDER_STATUS.HoanThanhText }
    ];
    const {
      handleSubmit,
      saleReport: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="denNgay" placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="2" className="mb-2">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.loaiDonHang} onChange={this.handleSelectChange.bind(this, "loaiDonHang")}>
                      <option value="">Loại đơn hàng</option>
                      <option value={1}>Đơn đặt hàng</option>
                      <option value={2}>Đơn đặt hàng đại lý</option>
                      <option value={3}>Đơn trả hàng</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword"
                      placeholder="Mã hàng, tên hàng"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOption}
                    onChange={this.handleChangeTrangThai}
                    options={baoCaoTrangThai}
                    placeholder="Trạng thái"
                    className="form-control p-0"
                    isMulti
                    closeMenuOnSelect={false}
                  />
                </Col>

                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={treeNvkd}
                      isMultiChoice={false}
                      checked={this.state.multipleValueNVKD}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionNhomKhachHang}
                    onChange={this.handleChangeNhomKhachHang}
                    options={listNhomKhachHang}
                    placeholder="Nhóm khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionKhachHang}
                    onChange={this.handleChangeKhachHang}
                    options={listKhachHang}
                    placeholder="Khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mt-2 mb-2">
            <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
            <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Số phiếu</th>
                    <th scope="col" className="text-left">Ngày lập</th>
                    <th scope="col" className="text-left">Ngày giao</th>
                    <th scope="col" className="text-left">Mã khách hàng</th>
                    <th scope="col" className="text-left">Khách hàng</th>
                    <th scope="col" className="text-left">Nơi xuất hàng</th>
                    <th scope="col" className="text-left">Mã thuốc</th>
                    <th scope="col" className="text-left">Tên thuốc</th>
                    <th scope="col" className="text-left">NVKD</th>
                    <th scope="col" className="text-right">Số lượng</th>
                    <th scope="col" className="text-center">Doanh thu<br />chưa CK</th>
                    <th scope="col" className="text-center">Doanh thu<br />đã CK</th>
                    <th scope="col" className="text-center">SL trả lại</th>
                    <th scope="col" className="text-center">Giá trị trả lại</th>
                    <th scope="col" className="text-center">DS Trình</th>
                    <th scope="col" className="text-center">CK Hợp đồng</th>
                    {/* <th scope="col" className="text-right">Điểm</th> */}
                    <th scope="col" className="text-left">Trạng thái</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="10" className="text-right">
                      Tổng cộng:
                    </th>
                    <th scope="col" className="text-right">
                     <span className="text-success">
                        {this.state.tong_soLuong &&
                          this.state.tong_soLuong.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhThuChuaCK &&
                          this.state.tong_doanhThuChuaCK.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhThu &&
                          this.state.tong_doanhThu.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-danger">
                        {this.state.tong_soLuongTra &&
                          this.state.tong_soLuongTra.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-danger">
                        {this.state.tong_doanhThuTra &&
                          this.state.tong_doanhThuTra.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhSoTDV &&
                          this.state.tong_doanhSoTDV.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhSoCKKH &&
                          this.state.tong_doanhSoCKKH.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    {/* <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_diem &&
                          this.state.tong_diem.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th> */}
                    <th scope="col" className="text-right">
                    </th>
                  </tr>
                </tfoot>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.MaDonHang}</td>
                        <td className="text-left">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-left">{res.NgayGiao && <Moment format="HH:mm DD/MM">{`${res.NgayGiao}`}</Moment>}</td>
                        <td className="text-left">{res.MaKhachHang}</td>
                        <td className="text-left">{res.TenKhachHang}</td>
                        <td className="text-left">{res.NoiXuat}</td>
                        <td className="text-left">{res.Sku}</td>
                        <td className="text-left">{res.TenHang}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-right"> {parseFloat(res.SoLuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right"> {parseFloat(res.DoanhSoChuaCK || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right"> {parseFloat(res.DoanhSoSauCK || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger"> {parseFloat(res.SoLuongTra || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger"> {parseFloat(res.DoanhSoTra || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right"> {parseFloat(res.DoanhSoTDV || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right"> {parseFloat(res.doanhSoCKKH || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.TemTrangThai}</td>
                      </tr>
                    ))
                  )}
                </tbody>

              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  saleReport: state.saleReport,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  saleReportNvkdRequest: saleAction.saleReportNvkdRequest,
  saleReportKhRequest: saleAction.saleReportKhRequest,
  saleReportListRequest: saleAction.saleReportListRequest,
  reportExportXlsRequest: saleAction.reportExportXlsRequest,
  saleReportNhomKhRequest: saleAction.saleReportNhomKhRequest,
  saleReportKhByNhomRequest: saleAction.saleReportKhByNhomRequest
})(SaleReport)

const formed = reduxForm({
  form: 'saleReport',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/SaleReport.js